import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';


// Styled Components
const CodeBlockContainer = styled.div`
  position: relative;
  margin-bottom: 10px;
`;

const CopyButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: #66023c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;

  &:hover {
    background: #7a1c53b5;
  }
`;

const CodeBlock = ({ children }) => {
  const [buttonText, setButtonText] = useState('Copy');

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(children)
      .then(() => {
        setButtonText('Copied!');
        setTimeout(() => setButtonText('Copy'), 2000); // Reset button text after 2 seconds
      })
      .catch((err) => {
        console.error('Could not copy text: ', err);
      });
  };

  return (
    <CodeBlockContainer>
      <CopyButton onClick={copyToClipboard}>{buttonText}</CopyButton>
      <pre>{children}</pre>
    </CodeBlockContainer>
  );
};

CodeBlock.propTypes = {
  children: PropTypes.node.isRequired, 
};

export default CodeBlock;
